module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wtm-spinix.94be3a3c.png";